/* eslint-disable react/react-in-jsx-scope */
import './App.css';
import Navbar from './components/Navbar';
import Signup from './components/Signup';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Signup />
    </div>
  );
}

export default App;
